import React from 'react'
import '../styles/Gallery.css'
import ImagesGrid from '../components/gallery/ImagesGrid';
import GalleryCarousel from '../components/gallery/GalleryCarousel';

const Gallery = () => {
  return (
    <div className='minHeight100'>
      <div className='hero-section'>
        <h2 className='pagetitle'>GALLERY</h2>
      </div>

      <div className='featured-section'>
        <div className='section-container'>
          <h2 className='section-title'>FEATURED MOMENTS</h2>
          <div className='featured-intro'>
            <p className='intro-text'>
              Highlights from our most prestigious events and celebrity gifting experiences
            </p>
          </div>
          <div className='carousel-wrapper'>
            <GalleryCarousel />
          </div>
        </div>
      </div>

      <div className='gallery-grid-section'>
        <div className='section-container'>
          <h2 className='section-title'>EVENT GALLERY</h2>
          <div className='gallery-intro'>
            <p className='intro-text'>
              Explore our complete collection of moments from red carpet events, backstage experiences, 
              and exclusive celebrity gifting sessions that have defined Gift Bags by Rachael's legacy.
            </p>
          </div>
          <div className='images-grid-wrapper'>
            <ImagesGrid />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Gallery